import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from './login/login.component';
import { DOCUMENT, Location } from '@angular/common';
import { Router } from '@angular/router'
import { OrdinaryQuery, QueryVhweb } from 'private-angular-vhframeworks';
import { Platform } from '@ionic/angular';
import { support } from 'jquery';
export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Inject(DOCUMENT) document
  href: string;
  showsearch: boolean = false;
  listHardware: any;
  list: any = [];
  products: any = new Object({
    software: [],
    iot: [],
    solution: [],
    all: []
  })
  showicon: boolean = false;
  showFirst: boolean;
  panelOpenState = false;
  show_payinfo: boolean = false;
  show_searchbar: boolean = false;
  show_keyboard: boolean = false;
  showitem: boolean = false;
  showsolution: boolean = false;
  showsupport: boolean = false
  openSales = 1;
  isMobile: boolean
  showMenu : boolean = false
  constructor(
    public dialog: MatDialog,
    private location: Location,
    private router: Router,
    private ordinaryQuery: OrdinaryQuery,
    private queryVhweb: QueryVhweb,
    public platform: Platform,
  ) {
    if (platform.width() < 768) this.isMobile = true
    else if (platform.is("android") || platform.is("ios")) this.isMobile = false
    else this.isMobile = false
  }
  dataShow: any = [];
  go(i) {
    this.value = i
  }
  value: any = {
    id: 0,
    status: '',
  }
  clickshowicon() {
    this.showicon = !this.showicon
    this.show_payinfo = false
    this.showitem = false
    this.showsolution = false
    this.showsupport = false
  }
  clickshow() {
    this.show_payinfo = !this.show_payinfo
    this.showicon = false
    this.showitem = false
    this.showsolution = false
    this.showsupport = false
  }
  clickitem() {
    this.showitem = !this.showitem
    this.showicon = false
    this.show_payinfo = false
    this.showsolution = false
    this.showsupport = false
  }
  clicksolution() {
    this.showsolution = !this.showsolution
    this.showicon = false
    this.showitem = false
    this.show_payinfo = false
    this.showsupport = false
  }
  clicksupport() {
    this.showsupport = !this.showsupport
    this.showicon = false
    this.showitem = false
    this.showsolution = false
    this.show_payinfo = false
  }

  openDialog(): void {
    let width = this.platform.is("desktop") ? "60%" : "100%"
    const dialogRef = this.dialog.open(LoginComponent, {
      width: width,
      maxWidth: "100%",
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
  ngOnInit(): void {
    this.getProduts();
    this.getListHardware();
    this.href = this.router.url;
    
  }


  getListHardware() {
    this.queryVhweb.getProducts("hardwares")
      .then(res => {
        this.listHardware = res.docs.map(item => {
          return { ...item.data(), id: item.id }
        })

      })
  }
  getProduts() {
    this.ordinaryQuery.getTasks_by1Field_1Field1Value('products', 'status', "==", true).then(async res => {

      this.products['all'] = await res.docs.map(item => {
        return { id: item.id, ...item.data() }
      }).sort((prev, next) => {
        if (prev.date.seconds > next.date.seconds) return -1
        else if (prev.date.seconds < next.date.seconds) return 1
        else return 0
      });

      // Filter theo thể loại
      this.products['software'] = this.products['all'].filter(item => item.type == "1")
      this.products['iot'] = this.products['all'].filter(item => item.type == "2")
      this.products['solution'] = this.products['all'].filter(item => item.type == "3")

    })
  }
  goto_detail(id) {

  }
  goto_news() {
    this.router.navigateByUrl("tin-tuc")
  }
  getLastPath() {
    return this.location.path()
  }
  getLastPathParent() {
    return this.location.path().split('/')[1]
  }
  getLastPathItem() {
    return this.location.path().split('/')[2]
  }

  goto_home() {
    this.router.navigate(["./"], { state: { data: '1asd' } });
  }

  goto_software() {
    this.router.navigateByUrl("software")
  }
  goto_product() {
    this.router.navigateByUrl("san-pham")
  }
  goto_interface_store() {
    this.router.navigateByUrl("kho-giao-dien")
  }
  goto_solution() {
    this.router.navigateByUrl("solution")
  }
  goto_machining() {
    this.router.navigateByUrl("outsource")
  }
  goto_sell() {
    this.router.navigate(["./software/sale"]);
  }
  goto_food() {
    this.router.navigate(["./software/cafe"])
  }
  goto_cloud() {
    this.router.navigate(["./software/cloudcam"])
  }

  goto_receipts() {
    this.router.navigate(["./software/receipts-expenses"])
  }

  goto_power_monitoring() {
    this.router.navigate(["./solution/power-monitoring"])
  }

  goto_smarthome() {
    this.router.navigateByUrl("solution/smarthome");
  }
  goto_securityCam() {
    this.router.navigateByUrl("solution/security-cam");
  }

  goto_agricultural() {
    this.router.navigateByUrl("solution/agricultural");
  }

  goto_cloudcamservice() {
    this.router.navigateByUrl("solution/cloudcam-service");
  }

  goto_material() {
    this.router.navigate(["./solution/material-production"])
  }
  goto_support() {
    this.router.navigate(["./support"])
  }
  goto_support_sale() {
    this.router.navigate(["./support/sale"])
  }

  goto_support_food() {
    this.router.navigate(["./support/food"])
  }

  goto_introduction() {
    this.router.navigate(["./introduction"], { state: { data: '1asd' } })
  }

  goto_products() {
    this.router.navigate(["./products"])
  }
  goto_saleproduct() {
    this.router.navigate(["./sale-product"])
  }
  goto_smartproduct() {
    this.router.navigate(["./smart-product"])
  }
  goto_camproduct() {
    this.router.navigate(["./cam-product"])
  }
  goto_accessproduct() {
    this.router.navigate(["./accessory-product"])
  }
 
  goto_listPrice() {
    this.router.navigate(["./price"])
  }

  goto_contact() {
    this.router.navigate(["./contact"])
  }
  goto_website() {
    this.router.navigate(["./outsource/website"])
  }

  goto_appmobile() {
    this.router.navigate(['./outsource/app-mobile'])
  }

  goto_iot() {
    this.router.navigate(['./outsource/iot'])
  }

  goto_system() {
    this.router.navigate(['./outsource/system'])
  }
  goto_iotsolution() {
    this.router.navigate(['./solution/iot'])
  }
  goto_download() {
    this.router.navigate(['./download'])
  }
  goto_download_sale() {
    this.router.navigate(['./download/sales'])
  }
  goto_download_cafe() {
    this.router.navigate(['./download/cafe'])
  }
  goto_download_driver(){
    this.router.navigate(['./download/driver/xprinter'])
  }

  goto_hardwareDetail() {
    this.router.navigate(['./products/hardware-detail/:id'])
  }

  goto_bestprice_sales() {
    this.router.navigate(['./promotion-sales'])
  }
  goto_bestprice_cafe() {
    this.router.navigate(['./promotion-cafe'])
  }
  goto_bestprice_business() {
    this.router.navigate(['./promotion-products/packagestype/'], {
      queryParams: { type: 1 }
    })
  }
  go_promotion_products() {
    this.router.navigate(['./promotion-products/packagestype/'], {
      queryParams: { type: 1 }
    })
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

  }

  menu: boolean = false
  typeSoftware : number = 1
  openCafeMenu() {
    this.typeSoftware = 2
    this.menu = true
    this.name = 'Quản lý nhà hàng, cafe'
  }
  openSalesMenu() {
    this.typeSoftware = 1
    this.menu = true
    this.name = 'Quản lý bán hàng'
  }
  closeMenuSoftware(e) {
    this.menu = e

  }
  menu_product: boolean = false
  openProductMenu() {
    this.filed = this.listMenu
    this.menu_product = true
    this.name = 'Danh sách sản phẩm'
  }
  closeMenu(e) {
    this.menu_product = e
  }

  openCloudMenu() {
    this.filed = this.cloud
    this.menu = true
    this.name = 'Cloud camera'
  }

  support: boolean = false
  openSupports() {
    this.filed = this.supports
    this.support = true
    this.name = 'Hướng dẫn sử dụng phần mềm'
  }
  openDownloads() {
    this.filed = this.downloads
    this.support = true
    this.name = 'Tải phần mềm'
  }
  openDrivers() {
    this.filed = this.drivers
    this.support = true
    this.name = 'Tải phần mềm'
  }

  openSalesFuction() {
    if (this.openSales == 1) {
      this.openSales = 2;
    } else {
      this.openSales = 1;
    }

  }
  filed: any = []
  name: string
  gotoField(item) {
    this.router.navigate([item.path])
  }
  gotoFieldMobile(item) {
    this.menu = false
    this.router.navigate([item.path])
  }
  ///Hàm chuyển trang và thực hiện load
  // tham số truyền vào là 1 link
  reloadPage(_value) {
    let currentUrl = this.router.url; // lấy giá trị trang hiện tại
    if (currentUrl == _value) {  // trang hiện tai bằng với link đường truyền thì sẽ reload lại link với giá trị truyền vào
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
    } if (currentUrl != _value) {// trang hiện tại với link được truyền vào khác nhau thì thực hiện chuyển trang
      this.router.navigate([_value]);
    }
  }
  ///Thay đổi image khi hover
  setActiveImage(_name, _value): void {
    (document.getElementById(_name) as HTMLImageElement).src = _value;
  }
  setNoneImage(_name, _valueNone, _path): void {
    if (this.getLastPath() != _path) {
      (document.getElementById(_name) as HTMLImageElement).src = _valueNone;
    }
  }
  /** Hàm thực hiện chuyển trang
   * 
   * @param _path  //đường dẫn truyền vào 
   */
  routerItemProduct(_path) {
    let currentUrl = this.router.url; // lấy giá trị trang hiện tại
    if (_path.length > 0) {
      if (currentUrl == _path) {  // trang hiện tai bằng với link đường truyền thì sẽ reload lại link với giá trị truyền vào
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      } if (currentUrl != _path) {// trang hiện tại với link được truyền vào khác nhau thì thực hiện chuyển trang
        this.router.navigate([_path]);
      }
    } if (_path.length == 0) {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
    }

  }
  checkActiveDriver () : string {
    var i:string = this.location.path().split('/')[2];
    return i;
  }

  // sales: any = [
  //   {
  //     name: "Tạp hóa",
  //     icon: "assets/icon/download/taphoa.svg",
  //     icon_active: "assets/icon/download/taphoa_active.svg",
  //     img: "assets/img/download/taphoa.jpg",
  //     content: "Nếu bạn đang có ý định kinh doanh tạp hóa, phần mềm quản lý bán hàng Sales Viethas sẽ giúp bạn vững vàng hơn trong kế hoạch khởi nghiệp và nhanh chóng đạt được nhiều thành công. Quản lý sản phẩm và kiểm tra số lượng tồn kho thật dễ dàng, lúc nào cũng có sẵn hàng để bán mà không lo thiếu hụt.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/grocery'
  //   },
  //   {
  //     name: "Nội thất và gia dụng",
  //     icon: "assets/icon/download/noithat.svg",
  //     icon_active: "assets/icon/download/noithat_active.svg",
  //     img: "assets/img/download/noithat.jpg",
  //     content: "Những cách bán hàng thủ công đã trở nên quá lỗi thời trong thời đại công nghệ hiện nay. Đặc biệt với những bạn có ý định kiêm cả kinh doanh nội thất online hay kinh doanh đồ gia dụng online thì càng nên sử dụng phần mềm quản lý bán hàng Sales Viethas để bán tốt hơn.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/furniture'
  //   },
  //   {
  //     name: "Văn phòng phẩm",
  //     icon: "assets/icon/download/vanphongpham.svg",
  //     icon_active: "assets/icon/download/vanphongpham_active.svg",
  //     img: "assets/img/download/vanphongpham.jpg",
  //     content: "Văn phòng phẩm là những mặt hàng thông dụng không thể thiếu đối với học sinh, sinh viên và các công ty nên đây là cơ hội lớn để bạn thử sức kinh doanh. Phần mềm bán hàng cửa hàng sách văn phòng phẩm cho phép ghi nhận đầy đủ các thông tin hàng hóa về tên gọi, mã hiệu, mã vạch, nhà sản xuất và chi tiết từng đặc tính của mặt hàng.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/stationery'
  //   },
  //   {
  //     name: "Dịch vụ thú y",
  //     icon: "assets/icon/download/thuy.svg",
  //     icon_active: "assets/icon/download/thuy_active.svg",
  //     img: "assets/img/download/thuy.jpg",
  //     content: "Là một nghề chăm sóc, chữa trị,… cho động vật. Do đó để áp ứng nhu cầu mở dịch vụ, phần mềm Sales Viethas sẽ cho phép tạo các dịch vụ thú y thoải mái và không giới hạn, bên cạnh đó còn có thể bán các sản phẩm đi kèm, chẳng hạn như thức ăn chó mèo, thuốc trị ve...",
  //     type: 1,
  //     ok: false,
  //     path: '/field/veterinaryservices'

  //   },
  //   {
  //     name: "Thiết bị điện tử",
  //     icon: "assets/icon/download/thietbidientu.svg",
  //     icon_active: "assets/icon/download/thietbidientu_active.svg",
  //     img: "assets/img/download/thietbidientu.jpg",
  //     content: "Thiết bị điện tử là những vật dụng rất gần gũi và quen thuộc trong mỗi gia đình. Ngoài việc bán hàng, phần mềm Sales Viethas còn hỗ trợ tạo biên nhận, báo giá bảo hành sửa chữa giúp bạn thuận tiện trong việc mua bán và sửa chữa các thiết bị điện tử.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/electronic'

  //   },
  //   {
  //     name: "Mẹ & Bé",
  //     icon: "assets/icon/download/mevabe.svg",
  //     icon_active: "assets/icon/download/mevabe_active.svg",
  //     img: "assets/img/download/mevabe.jpg",
  //     content: "Khách hàng của các cửa hàng Mẹ & bé thường là những bà mẹ, bà nội trợ bận rộn. Vì vậy, họ không có nhiều thời gian dành cho việc mua sắm. Hãy giúp khách hàng của bạn tiết kiệm thời gian bằng việc sử dụng phần mềm quản lý bán hàng Sales Viethas, bạn có thể cùng lúc thanh toán nhiều đơn hàng, việc tìm kiếm sản phẩm, cộng tổng giá trị hoá đơn cũng được tự động trên máy tính.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/mombaby'

  //   },
  //   {
  //     name: "Phụ tùng xe máy",
  //     icon: "assets/icon/download/phutungxemay.svg",
  //     icon_active: "assets/icon/download/phutungxemay_active.svg",
  //     img: "assets/img/download/phutuxemay.jpg",
  //     content: "Không còn phải nhọc nhằn để bán các phụ tùng xe máy khi đã có phần mềm quản lý cửa hàng phụ tùng xe máy, chỉ cần sử dụng điện thoại thông minh là bạn có thể bán hàng nhanh chóng mà không cần đầu tư nhiều về thiết bị bán hàng.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/accessary'
  //   },
  //   {
  //     name: "Thực phẩm",
  //     icon: "assets/icon/download/thucphamtuoisong.svg",
  //     icon_active: "assets/icon/download/thucphamtuoisong_active.svg",
  //     img: "assets/img/download/thucphamtuoisong.jpg",
  //     content: "Sử dụng phần mềm quản lý thực phẩm tươi sống là lời khuyên của nhiều chủ cửa hàng đưa ra. Việc dùng phần mềm quản lý giúp cho việc bán hàng của cửa hàng nhanh hơn, chính xác hơn về số lượng, cũng như đơn giá của từng thực phẩm giúp khách hàng tin tưởng và hài lòng hơn khi mua thực phẩm của cửa hàng.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/food'
  //   },
  //   {
  //     name: "Cửa hàng 24h",
  //     icon: "assets/icon/download/sieuthimini.svg",
  //     icon_active: "assets/icon/download/sieuthimini_active.svg",
  //     img: "assets/img/download/sieuthimini.jpg",
  //     content: "Những cửa hàng tiện lợi luôn dành sự quan tâm cho những người đi làm ca đêm, tăng ca hoặc tan ca trễ hay các bạn sinh viên gặp gỡ làm bài tập nhóm. Phần mềm Sales Viethas quyết tâm “thâu đêm” cùng với bạn, giúp tăng doanh số và phục vụ người mua tốt hơn.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/store24h'

  //   },
  //   {
  //     name: "Quà lưu niệm",
  //     icon: "assets/icon/download/qualuuniem.svg",
  //     icon_active: "assets/icon/download/qualuuniem_active.svg",
  //     img: "assets/img/download/qualuuniem.jpg",
  //     content: "Hẳn ai cũng đều có món quà dành tặng cho người mình yêu, người trong gia đình và đặc biệt là quà kỷ niệm. Vậy thì ý tưởng mở shop quà lưu niệm rất là đúng thời điểm. Với Sales Viethas, bạn có thể bán sản phẩm theo từng loại hay bán theo dạng nhóm (combo), quản lý hàng hóa và số lượng tồn kho tốt hơn.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/souvenir'
  //   },
  //   {
  //     name: "Thời trang",
  //     icon: "assets/icon/download/thoitrang.svg",
  //     icon_active: "assets/icon/download/thoitrang_active.svg",
  //     img: "assets/img/download/thoitrang.jpg",
  //     content: "Bạn có nhiều bộ sưu tập thời trang cần được thanh lý ? Hay đơn thuần chỉ là người đam mê kinh doanh thời trang ? Bất kể là giày dép hay quần áo, phụ kiện thời trang thì Sales Viethas thừa khả năng quản lý, bán hàng.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/fashion'
  //   },
  //   {
  //     name: "Phụ kiện điện thoại",
  //     icon: "assets/icon/download/phukien.svg",
  //     icon_active: "assets/icon/download/phukien_active.svg",
  //     img: "assets/img/download/phukien.jpg",
  //     content: "Phụ kiện cho điện thoại đa dạng về màu sắc, thương hiệu và đặc biệt là sản phẩm, để quản lý tốt bạn chỉ cần dùng Sales Viethas. Không giới hạn sản phẩm được tạo trên app, không bị chậm khi tải nhiều sản phẩm trong lúc bán hàng.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/phone-accessory'
  //   },
  //   {
  //     name: "Cửa hàng điện nước",
  //     icon: "assets/icon/download/cungcapvattu.svg",
  //     icon_active: "assets/icon/download/cungcapvattu_active.svg",
  //     img: "assets/img/download/diennuoc.jpg",
  //     content: "Nhằm quản lý chính xác số lượng hàng hóa bán ra cũng như số lượng tồn kho của vật liệu, Sales Viethas báo cáo đầy đủ các thông tin cần thiết cho bạn, giúp bạn biết được sản phẩm bán ra bao nhiêu và còn tồn đọng bao nhiêu.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/electric'
  //   },
  //   {
  //     name: "Đại lý sữa",
  //     icon: "assets/icon/download/dailysua.svg",
  //     icon_active: "assets/icon/download/dailysua_active.svg",
  //     img: "assets/img/download/dailysua.jpg",
  //     content: "Kinh doanh sữa trẻ em có lời và chưa bao giờ hết “hot” bởi tỷ lệ dân số gia tăng mở ra cơ hội “béo bở” cho bất cứ ai biết nắm bắt thời cơ. Để đi đến một cửa hàng hoàn thiện cần trải qua nhiều giai đoạn, trong đó Viethas sẽ giúp bạn có một hệ thống bán hàng hoàn chỉnh, bạn không cần bận tâm khi bán hàng.",
  //     type: 1,
  //     ok: false,
  //     path: '/field/milk'
  //   },
  //   {
  //     name: "Bán hàng trên sàn TMĐT",
  //     icon: "assets/icon/download/tmdt.svg",
  //     icon_active: "assets/icon/download/tmdt_active.svg",
  //     img: "assets/img/download/tmdt.jpg",
  //     content: "Bạn đang kinh doanh trên các sàn thương mại điện tử, để quản lý các sàn thì bạn phải mở nhiều tab trình duyệt, đã vậy phải còn thuê nhiều nhân viên để quản lý từng sàn.. và tất nhiên sẽ có sai sót xảy ra như chậm xác nhận đơn hàng, bị sót đơn hàng để chuẩn bị hàng giao, đơn bị hủy do giao hàng thất bại hay do khách vừa đặt xong hủy ? Hàng hóa đã được đóng gói và giao cho Shipper chưa ? Đó là câu hỏi của các nhà bán khi có nhiều đơn hàng trong ngày. Tính năng quản lý sàn TMDT cho phép quản lý đơn hàng trên mọi sàn TMDT hiện có tại Việt nam, ngoài quản lý đơn hàng bạn còn được thay đổi giá bán sản phẩm, thay đổi tồn kho sản phẩm trên sàn hoặc bật hay ẩn sản phẩm khỏi sàn.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/ecommerce'
  //   },
  //   {
  //     name: "Ngành nghề khác",
  //     icon: "assets/icon/download/khac.svg",
  //     icon_active: "assets/icon/download/khac_active.svg",
  //     img: "assets/img/download/khac.jpg",
  //     content: "Viethas sẽ xem ngành hàng kinh doanh của bạn và sắp xếp phần mềm phù hợp với bạn hơn.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/other'
  //   },
  //   {
  //     name: "Kinh Doanh Sỉ và lẻ",
  //     icon: "assets/icon/download/sivale.svg",
  //     icon_active: "assets/icon/download/sivale_active.svg",
  //     img: "assets/img/download/sivale.jpg",
  //     content: "Đối với các doanh nghiệp vừa bán buôn và bán lẻ thì công việc quản lý hàng hóa khá rắc rối. Cùng với số lượng lớn hàng hóa, chủ doanh nghiệp không chỉ cần đảm bảo tồn kho sản phẩm mà còn phải quản lý các hoạt động xuất nhập hàng. Với Phần mềm quản lý bán hàng Viethas, tất cả những công việc đó sẽ trở nên đơn giản.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/sivale'
  //   },
  //   {
  //     name: "Phân phối hàng hóa",
  //     icon: "assets/icon/download/phanphoihanghoa.svg",
  //     icon_active: "assets/icon/download/phanphoihanghoa_active.svg",
  //     img: "assets/img/download/phanphoihanghoa.jpg",
  //     content: "Với các doanh nghiệp phân phối hàng hóa thì việc quản lý các mặt hàng, tồn kho mặt hàng và theo dõi xuất nhập hàng vô cùng quan trọng. Đây cũng là yếu tố quyết định sự thành bại của doanh nghiệp. Chính vì thế, Phần mềm quản lý bán hàng Viethas đã ra đời, trở thành giải pháp không thể thiếu của các nhà sản xuất và phân phối hiện nay.",
  //     type: 1,
  //     ok: true,
  //     path: '/field/distributed'
  //   },
  // ]
  //cafe
  // cafe: any = [{
  //   name: "Nhà hàng",
  //   icon: "assets/icon/download/nhahang.svg",
  //   icon_active: "assets/icon/download/nhahang_active.svg",
  //   img: "assets/img/download/nhahang.jpg",
  //   content: "Dựa trên hiểu biết & nghiên cứu của các chuyên gia trong nghiệp vụ vận hành nhà hàng Viethas thiết kế giao diện bán hàng vô cùng tinh tế, đơn giản và dễ sử dụng. Màn hình bán hàng được thiết kế dành riêng cho nhân viên phục vụ. Bạn hoàn toàn có thể thao tác nhanh trong việc chọn bàn, gọi món theo yêu cầu của khách hàng.",
  //   type: 2,
  //   ok: true,
  //   path: '/field/restaurant'
  // },
  // {
  //   name: "Cafe",
  //   icon: "assets/icon/download/caphe.svg",
  //   icon_active: "assets/icon/download/caphe_active.svg",
  //   img: "assets/img/download/caphe.jpg",
  //   content: "Mô hình kinh doanh này hẳn không còn lạ ở đất nước chúng ta, tuy nghe đơn giản nhưng để quản lý cafe sân vườn không hề đơn giản, phần mềm quản lý cafe Viethas sẽ tối ưu trong việc quản lý nguyên liệu, cũng như các thành phần tạo nên thức uống.",
  //   type: 2,
  //   ok: true,
  //   path: '/field/coffeegarden'
  // },
  // {
  //   name: "Khách sạn, nhà nghỉ",
  //   icon: "assets/icon/download/khachsan.svg",
  //   icon_active: "assets/icon/download/khachsan_active.svg",
  //   img: "assets/img/download/khachsan.jpg",
  //   content: "Với xu hướng phải triển mạnh mẽ của ngành du lịch, kinh doanh khách sạn - nhà nghỉ cũng trở thành lựa chọn của nhiều người hiện nay. Tuy nhiên, làm thế nào để quản lý vận hành một khách sạn hiệu quả nhất? Câu trả lời chính là Phần mềm dành riêng cho khách sạn, nhà nghỉ Viethas với hơn 50.000 chủ kinh doanh sử dụng!",
  //   type: 2,
  //   ok: false,
  //   path: '/field/hotel'
  // },
  // {
  //   name: "Khu du lịch",
  //   icon: "assets/icon/download/dulich.svg",
  //   icon_active: "assets/icon/download/dulich_active.svg",
  //   img: "assets/img/download/khudulich.jpg",
  //   content: "Khu du lịch và resort cũng được xem là những nơi thu hút khách nhất vào những dịp lễ, hoặc tết hay những ngày nghỉ của gia đình. Phần mềm quản lý khu du lịch và resort Viethas thao tác đơn giản, dễ dùng là một điểm ưu rất lớn trong những ngày đông khách.",
  //   type: 2,
  //   ok: true,
  //   path: '/field/tourism'
  // },
  // {
  //   name: "Làng nướng",
  //   icon: "assets/icon/download/langnuong.svg",
  //   icon_active: "assets/icon/download/langnuong_active.svg",
  //   img: "assets/img/download/langnuong.jpg",
  //   content: "Bạn có ý định kinh doanh làng nướng? Vậy bạn có nghe tới phần mềm quản lý nhà hàng làng nướng Viethas chưa? Ngoài quản lý các món ăn đơn thuần thì phần mềm còn có chức năng tạo combo món ăn, bạn có thể tạo combo đó dựa trên những món ăn riêng biệt!",
  //   type: 2,
  //   ok: true,
  //   path: '/field/villagebbq'
  // },
  // {
  //   name: "Trà sữa",
  //   icon: "assets/icon/download/trasua.svg",
  //   icon_active: "assets/icon/download/trasua_active.svg",
  //   img: "assets/img/download/trasua.jpg",
  //   content: "Ai ai cũng muốn mở 1 tiệm trà sữa cho riêng mình đúng không ? Vừa bán ngon lại vừa có tiếng thì luôn có doanh thu cao! Phần mềm quản lý café, trà sữa Viethas tối ưu trong việc quản lý topping, thao tác gọi thức uống cực kì đơn giản và nhanh chóng.",
  //   type: 2,
  //   ok: true,
  //   path: '/field/milktea'
  // },
  // {
  //   name: "Bar/ Club",
  //   icon: "assets/icon/download/bar.svg",
  //   icon_active: "assets/icon/download/bar_active.svg",
  //   img: "assets/img/download/bar.jpg",
  //   content: "Viethas cho ra phần mềm quản lý Bar/club ở cả 2 nền tảng iOS và Android. Điều này không chỉ giúp Nhân viên dễ dàng thao tác nhận order của khách và chuyển các yêu cầu tới bếp hoặc thu ngân, mà còn giảm chi phí đầu tư các thiết bị di động khi bất cứ chiếc điện thoại thông minh nào của nhân viên nhà hàng cũng có thể cài ứng dụng Cafe Viethas.",
  //   type: 2,
  //   ok: true,
  //   path: '/field/barclub'
  // },
  // {
  //   name: "Karaoke",
  //   icon: "assets/icon/download/karaoke.svg",
  //   icon_active: "assets/icon/download/karaoke_active.svg",
  //   img: "assets/img/download/kara.jpg",
  //   content: "Viethas cho ra phần mềm quản lý Karaoke ở nhiêuf nền tảng iOS, Android, Website, Desktop. Điều này không chỉ giúp Nhân viên dễ dàng thao tác nhận order của khách và chuyển các yêu cầu tới bếp hoặc thu ngân, mà còn giảm chi phí đầu tư các thiết bị di động khi bất cứ chiếc điện thoại thông minh nào của nhân viên nhà hàng cũng có thể cài ứng dụng Cafe Viethas.",
  //   type: 2,
  //   ok: true,
  //   path: '/field/karaoke'
  // },
  // {
  //   name: "Thức ăn nhanh",
  //   icon: "assets/icon/download/thucannhanh.svg",
  //   icon_active: "assets/icon/download/thucannhanh_active.svg",
  //   img: "assets/img/download/thucannhanh.jpg",
  //   content: "Hàng loạt chuỗi cửa hàng đồ ăn nhanh mở ra liên tục trong thời gian ngắn đã cho thấy sự phát triển liên tục của lĩnh vực này. Tuy nhiên, để vận hành và quản lý chuỗi cửa hàng này không phải là điều dễ dàng, phần mềm quản lý bán hàng là một trong những công cụ hữu hiệu nhất trong việc quản lý cửa hàng đồ ăn nhanh.",
  //   type: 2,
  //   ok: true,
  //   path: '/field/fastfood'
  // },
  // {
  //   name: "Tiệm chè",
  //   icon: "assets/icon/download/quanche.svg",
  //   icon_active: "assets/icon/download/quanche_active.svg",
  //   img: "assets/img/download/che.jpg",
  //   content: "Chè táo xọn, chè bà ba nóng hổi đây!!! Mô hình kinh doanh rao bán ngày ấy nay còn đâu, chỉ cần bảng hiệu neon chạy chữ nổi đèn chớp là đã có khách vào, Café Viethas cũng tận dụng điều đó mà giúp bạn tính toán về doanh thu, doanh số của mình hiệu quả hơn.",
  //   type: 2,
  //   ok: true,
  //   path: '/field/beverage-store'
  // },
  // {
  //   name: "Quán ăn tự phục vụ",
  //   icon: "assets/icon/download/tuphucvu.svg",
  //   icon_active: "assets/icon/download/tuphucvu_active.svg",
  //   img: "assets/img/download/tuphucvu.jpg",
  //   content: "Nhu cầu về công nghệ phục vụ ngày càng tăng, để đáp ứng cho chủ quán và môi trường kinh doanh F&B trở nên linh hoạt, Café Viethas đã mở rộng tính năng giao diện bán hàng dành cho khách tự gọi món, thay vì phục vụ khách theo kiểu truyền thồng phải có nhân viên gọi món thì tính năng này sẽ thay đổi hoạt động của cửa hàng. Khách hàng có thể gọi món tùy thích, tự lựa chọn món yêu thích và máy sẽ “order” xuống bếp sau khi khách đã thanh toán.",
  //   type: 2,
  //   ok: true,
  //   path: '/field/self-service'
  // },
  // {
  //   name: "Tiệc buffet",
  //   icon: "assets/icon/download/buffet.svg",
  //   icon_active: "assets/icon/download/buffet_active.svg",
  //   img: "assets/img/download/buffet.jpg",
  //   content: "Bạn có quản lý hết được các món ăn đã lên chưa ? Café Viethas giúp người quản lý kiểm tra xem món nào đã được lên, món nào chưa được lên và có thời gian cảnh báo trễ món.",
  //   type: 2,
  //   ok: true,
  //   path: '/field/buffet'
  // },
  // {
  //   name: "Bán trên GrabFood",
  //   icon: "assets/icon/download/online.svg",
  //   icon_active: "assets/icon/download/online_active.svg",
  //   img: "assets/img/download/online.jpg",
  //   content: "Bạn là chủ cửa hàng kinh doanh tại chỗ và bán trên Grabfood ? Bạn quản lý đơn hàng không xuể do vừa bán song song ? Bạn tìm đến Café Viethas là rất đúng chỗ luôn, vì Café Viethas hỗ trợ bán món ăn tại quán, đồng thời hỗ trợ quản lý đơn hàng trên grab food mà không bị rối như những phần mềm khác. Báo cáo doanh thu rõ ràng v trực quan, tổng kết hóa đơn bán trong ngày.",
  //   type: 2,
  //   ok: true,
  //   path: '/field/grabfood'

  // },
  // {
  //   name: "Quán ăn vặt",
  //   icon: "assets/icon/download/anvat.svg",
  //   icon_active: "assets/icon/download/anvat_active.svg",
  //   img: "assets/img/download/anvat.jpg",
  //   content: "Là tín đồ ăn vặt, thì quyết định mở quán chuyên bán đồ ăn vặt là cực kì chính xác! Vừa mở bán và vừa măm măm luôn. Nói vậy thôi, chứ Café Viethas sắp xếp rõ ràng à, món ăn của bàn nào là của bàn đó, đơn nào ra đơn đó cho Shipper, ai tới trước hay tới sau đều phải đợi có món thôi.",
  //   type: 2,
  //   ok: true,
  //   path: '/field/snacks'

  // },
  // {
  //   name: "Bida",
  //   icon: "assets/icon/download/bida.svg",
  //   icon_active: "assets/icon/download/bida_active.svg",
  //   img: "assets/img/download/bida.jpg",
  //   content: "Bạn có nhu cầu kinh doanh cửa hàng Bida ? Viethas có phần mềm riêng biệt dùng để quản lý giờ chơi, thuê dụng cụ hay sử dụng dịch vụ ăn uống đi kèm. Bạn vừa thảnh thơi quản lý vừa thảnh thơi chơi bida.",
  //   type: 2,
  //   ok: false,
  //   path: '/field/bida'
  // },
  //   // {
  //   //   name: "Khác",
  //   //   icon: "assets/icon/download/khac.svg",
  //   //   icon_active: "assets/icon/download/khac_active.svg",
  //   //   img: "assets/img/download/khac_cafe.jpg",
  //   //   content: "Viethas sẽ xem ngành hàng kinh doanh của bạn và sắp xếp phần mềm phù hợp với bạn hơn.",
  //   //   type: 2,
  //   //   ok: true,
  //   // }
  // ]
  cloud: any = [{
    name: "Theo dõi và lưu trữ không giới hạn",
    icon: "assets/icon/download/cloudcamera.svg",
    icon_active: "assets/icon/download/cloudcamera_active.svg",
    img: "assets/img/download/cloudcamera.jpg",
    content: "Nếu bạn đang có ý định kinh doanh tạp hóa, phần mềm quản lý bán hàng Sales Viethas sẽ giúp bạn vững vàng hơn trong kế hoạch khởi nghiệp và nhanh chóng đạt được nhiều thành công. Quản lý sản phẩm và kiểm tra số lượng tồn kho thật dễ dàng, lúc nào cũng có sẵn hàng để bán mà không lo thiếu hụt.",
    type: 1,
    ok: true,
    // path: '/outsource/iot'
  }]

  listMenu: any = [
    {
      name: 'Thiết bị bán hàng',
      pathImage: 'assets/img/new-product/menu/thiet-bi-ban-hang.png',
      path: '/product-list/selling'
    },
    {
      name: 'Thiết bị tin học văn phòng',
      pathImage: 'assets/img/new-product/menu/vi-tinh-van-phong.png',
      path: '/product-list/office'
    },
    {
      name: 'Thiết bị định vị GPS',
      pathImage: 'assets/img/new-product/menu/gps.png',
      path: '/product-list/gps'

    },
    {
      name: 'Thiết bị chiếu sáng',
      pathImage: 'assets/img/new-product/menu/thiet-bi-chieu-sang.png',
      path: '/product-list/lighting-device'

    },
    {
      name: 'Thiết bị nghe nhìn',
      pathImage: 'assets/img/new-product/menu/thiet-bi-nghe-nhin.png',
      path: '/product-list/listen-and-see'
    },
    {
      name: 'Thiết bị an ninh, cảnh báo',
      pathImage: 'assets/img/new-product/menu/thiet-bi-an-ninh.png',
      path: '/product-list/security'
    },
    {
      name: 'Camera quan sát',
      pathImage: 'assets/img/new-product/menu/camera-quan-sat.png',
      path: '/product-list/camera'
    },
    {
      name: 'Camera hành trình, máy quay',
      pathImage: 'assets/img/new-product/menu/camera-hanh-trinh.png',
      path: '/product-list/camera-journey'
    },
    {
      name: 'Máy in 3D',
      pathImage: 'assets/img/new-product/menu/may-in-3d.png',
      path: '/product-list/print3d'
    },
    {
      name: 'Máy in laser-CNC mini',
      pathImage: 'assets/img/new-product/menu/may-cat-laser.png',
      path: '/product-list/laser-cnc'
    },
    {
      name: 'Thiết bị nhà thông minh',
      pathImage: 'assets/img/new-product/menu/smarthome.png',
      path: '/product-list/smart'
    },
    {
      name: 'Thiết bị âm thanh (TOA)',
      pathImage: 'assets/img/new-product/menu/TOA-01.png',
      path: '/product-list/toa-device'
    },
  ];
  supports: any = [
    {
      name: "Quản lý bán hàng",
      path: '/support/sale'
    },
    {
      name: "Quản lý nhà hàng, cafe",
      path: '/support/food'
    },
    // {
    //   name: "Quản lý nhà thông minh",
    //   path: ''
    // },
    // {
    //   name: "Quản lý nhà Clouldcam",
    //   path: ''
    // }
  ]

  downloads: any = [
    {
      name: "Quản lý nhà hàng Sales Viethas",
      path: '/download/sales'
    },
    {
      name: "Quản lý nhà hàng, Café Viethas",
      path: '/download/cafe'
    },
    // {
    //   name: "Quản lý nhà thông minh Smarthome Viethas",
    //   path: ''
    // },
    // {
    //   name: "Quản lý Cloulcam Viethas",
    //   path: ''
    // },
  ]
  drivers: any = [
    {
      name: "Tải driver sản phẩm",
      path: '/download/driver'
    },
    // {
    //   name: "Camera, đầu ghi, camera hành trình",
    //   path: ''
    // },
    // {
    //   name: "Máy in 3D, cắt Lazer,CNC mini",
    //   path: ''
    // },
  ]

}
